export default {
  'barinka-bash': require('./barinka-bash').default,
  'pavlik-spectre-meltdown': require('./pavlik-spectre-meltdown').default,
  'miler-hesla': require('./miler-hesla').default,
  'holecek-pxe': require('./holecek-pxe').default,
  'hala-dnssec': require('./hala-dnssec').default,
  'franc-vyvoj': require('./franc-vyvoj').default,
  'zandl-turris': require('./zandl-turris').default,
  'cejka-nmap': require('./cejka-nmap').default,
  'koci-wifi': require('./koci-wifi').default,
  'stehlik-orange-pi': require('./stehlik-orange-pi').default,
  'hodac-vim': require('./hodac-vim').default,
  'pulec-ssh': require('./pulec-ssh').default,
  'vondra-virt': require('./vondra-virt').default,
  'ansorgova-dokumentacia': require('./ansorgova-dokumentacia').default,
  'polasek-plosne-spoje': require('./polasek-plosne-spoje').default,
  'sika-i3': require('./sika-i3').default,
  'caletka-netiketa': require('./caletka-netiketa').default,
  'benes-reinstall': require('./benes-reinstall').default,
  'krcmar-sifrovany-disk': require('./krcmar-sifrovany-disk').default,
  'becvarik-virtualy': require('./becvarik-virtualy').default,
  'baler-wireguard': require('./baler-wireguard').default,
  'becvarik-domaci-bydleni': require('./becvarik-domaci-bydleni').default,
  'sojka-openwrt': require('./sojka-openwrt').default,
  'snajdr-vpsadminos': require('./snajdr-vpsadminos').default,
  'kaplan-icinga': require('./kaplan-icinga').default,
  'ziegler-sitove-simulatory': require('./ziegler-sitove-simulatory').default,
  'bedrich-python': require('./bedrich-python').default,
  'vician-linux': require('./vician-linux').default,
  'veverka-docker': require('./veverka-docker').default,
  'hroncok-hra-python': require('./hroncok-hra-python').default,
  'novy-stec-zabezpeceni': require('./novy-stec-zabezpeceni').default,
  'uhlik-vi': require('./uhlik-vi').default,
  'vondra-vykon': require('./vondra-vykon').default,
  'jilek-cmd': require('./jilek-cmd').default,
  'pluskal-opensuse': require('./pluskal-opensuse').default,
  'puzman-archlinux': require('./puzman-archlinux').default,
  'iliushin-hacking-101': require('./iliushin-hacking-101').default,
  'ziegler-sitove-simulatory-ws': require('./ziegler-sitove-simulatory-ws')
    .default,
  'caletka-ripe': require('./caletka-ripe').default,
  'zapletal-foreman': require('./zapletal-foreman').default,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/index.js